/* global yaCounter66980659 */

import scrollDepth from 'scroll-depth';
import vars from '../helpers';

function start15SecTimeout() {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter66980659) {
		yaCounter66980659.hit(path);
	}
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

function init() {
	// start
	$('.header__client').on('click.analytics', () => {
		ga('send', 'event', 'client link', 'logo header');
		ga('rbcspec.send', 'event', 'client link', 'click');
	});

	$('.header__logo').on('click.analytics', () => {
		ga('send', 'event', 'nav', 'rbc logo');
	});

	$('.header__button').on('click.analytics', () => {
		if (vars.$html.hasClass('open-menu')) {
			ga('send', 'event', 'nav', 'menu close');
		} else {
			ga('send', 'event', 'nav', 'menu open');
		}
	});

	$('.menu__nav a').on('click.analytics', (e) => {
		let name = $(e.currentTarget).text();

		ga('send', 'event', 'nav', 'menu item click', name);
	});

	$('.article__pages-item').on('click.analytics', () => {
		ga('send', 'event', 'nav', 'circle click');
	});

	$('.index__link').on('click.analytics', (e) => {
		let name = `${$(e.currentTarget).find('span:eq(0)').text()} ${$(e.currentTarget).find('span:eq(1)').text()}`;

		ga('send', 'event', 'main', 'material click', name);
	});

	// TODO: Добавить ссылку на сайт клиента
	$('.article p a').on('click.analytics', (e) => {
		let name = $(e.currentTarget).text();
		let link = $(e.currentTarget).attr('href');

		if (link.indexOf('#') > 0) {
			ga('send', 'event', 'client link', 'article text link', name);
			ga('rbcspec.send', 'event', 'client link', 'click');
		} else {
			ga('send', 'event', 'article', 'article text link', name);
		}
	});

	$('.article__insertion .article__share-button').on('click.analytics', (e) => {
		let name = $(e.currentTarget).data('social');

		ga('send', 'event', 'share', 'article share', name);
	});

	$('.article__footer .article__share-button, .share__btn, .social__btn').on('click.analytics', (e) => {
		let name = $(e.currentTarget).data('social');

		ga('send', 'event', 'share', 'project share', name);
	});

	$('.article__more-content-item').on('click.analytics', (e) => {
		let name = $(e.currentTarget).text();

		ga('send', 'event', 'article', 'see also', name);
	});

	$('.article__more-button').on('click.analytics', () => {
		ga('send', 'event', 'client link', 'product tizer click');
		ga('rbcspec.send', 'event', 'client link', 'click');
	});

	$('.article__more-arc-text').on('click.analytics', () => {
		ga('send', 'event', 'client link', '75 years button');
		ga('rbcspec.send', 'event', 'client link', 'click');
	});

	$('.js-language-switcher').on('click.analitycs', (e) => {
		let name = $(e.currentTarget).text();

		ga('send', 'event', 'nav', 'language change', name);
	});
}

function destroy() {
	$('.header__client').off('click.analytics');
	$('.header__logo').off('click.analytics');
	$('.header__button').off('click.analytics');
	$('.menu__nav a').off('click.analytics');
	$('.article__pages-item').off('click.analytics');
	$('.index__link').off('click.analytics');
	$('.article p a').off('click.analytics');
	$('.article__insertion .article__share-button').off('click.analytics');
	$('.article__footer .article__share-button, .share__btn').off('click.analytics');
	$('.article__more-content-item').off('click.analytics');
	$('.article__more-button').off('click.analytics');
	$('.article__more-arc-text').off('click.analytics');
	$('.js-language-switcher').on('click.analitycs');
}

vars.$document
	.on('video-play', (e, name) => {
		ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
		ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
	})
	.on('video-10-sec', (e, name) => {
		ga('send', 'event', 'video', 'timing 10s', name, 10);
		ga('rbcspec.send', 'event', 'video', 'timing 10s', '', 10);
	})
	.on('video-end', (e, name) => {
		ga('send', 'event', 'video', 'finish', name);
		ga('rbcspec.send', 'event', 'video', 'finish');
	})
	.on('video-first-click', (e, name) => {
		ga('send', 'event', 'article', 'video click', name);
	})
;

export default {
	start15SecTimeout,
	virtualHit,
	init,
	destroy,
};
